<template>
  <el-dialog title="发货" :visible.sync="deliveryStatus" width="50%">
    <el-form :model="orderForm" :rules="orderRules" ref="orderForm" label-width="100px">
      <el-form-item label="快递公司" prop="shipperName">
        <el-select
          v-model="orderForm.shipperName"
          placeholder="请选择快递公司"
          @change="changeShipperName"
        >
          <el-option
            v-for="item in courierList"
            :key="item.value"
            :label="item.shipperName"
            :value="item.shipperCode"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="快递邮编">
        <el-input
          disabled
          v-model="orderForm.shipperCode"
          placeholder="请输入邮编"
        ></el-input>
      </el-form-item>
      <el-form-item label="快递单号" prop="expressNo">
        <el-input v-model="orderForm.expressNo"></el-input>
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="center">
      <el-button type="primary" @click="handleSave">保存</el-button>
      <el-button @click="deliveryStatus = false">取消</el-button>
    </el-row>
  </el-dialog>

</template>


<script>
import {transDate} from "@/utils/util";

export default {
  name: "orderDialog",
  props: {
    courierList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      deliveryStatus: false,
      orderForm: {
        shipperCode: "",
        expressNo: "",
        shipperName: ""
      },
      orderRules: {
        expressNo: [
          { required: true, message: "请输入快递单号", trigger: "blur" }
        ],
        shipperName: [
          { required: true, message: "请输入快递公司", trigger: "blur" }
        ],

      }
    }
  },
  methods: {
    async init(val){

      const res =  await this.$http.post('order/queryOne', {
        orderNumber: val
      })

      if(res.data.code ===200){
        this.orderForm = res.data.data
        this.deliveryStatus = true
      }else {
        this.$message.error(res.data.message)
      }

    },
    changeShipperName(val) {
      console.log(val, 261)
      const info = this.courierList.find(item => item.shipperCode === val)
      if (info) {
        this.orderForm.shipperCode = info.shipperCode
        this.orderForm.shipperName = info.shipperName
        this.orderForm.deliveryType = info.shipperCode
      }
    },
    handleSave(){
      this.$refs.orderForm.validate(async valid => {
        if (valid) {
          this.orderForm.orderStatus = 3
          this.orderForm.deliveryTime = transDate(new Date())
          // console.log(this.orderForm.deliveryTime )
          // return false
          const res = await this.$http.post('order/updateDelivery', this.orderForm)
          if (res.data.code === 200) {
            this.$message.success('发货成功')
            this.deliveryStatus = false
            this.$emit('getList')
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    }

  }
}
</script>

<style scoped lang="scss">

</style>
